/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './no-content.module.css';

interface NoContentProps {
    message: string;
    allowReload?: boolean;
    reloadAction?: () => void;
    reloadMessage?: string;
    lowProfile?: boolean;
    withMarginTop?: boolean;
    withMarginBottom?: boolean;
}

export const NoContent: React.FC<NoContentProps> = ({
    allowReload = false,
    message,
    reloadAction,
    reloadMessage,
    lowProfile = false,
    withMarginTop = true,
    withMarginBottom = true,
}) => {
    const { t } = useTranslation(['core']);

    return (
        <div
            style={{
                padding: lowProfile ? '1rem' : '2rem',
                margin: '0',
                marginTop: withMarginTop ? '1rem' : '0',
                marginBottom: withMarginBottom ? '1rem' : '0',
            }}
            className={styles.NoContent}
        >
            <p>{message}</p>
            {allowReload && (
                <button type="button" onClick={reloadAction} className={styles.ReloadButton} style={{ marginTop: '1rem' }}>
                    {reloadMessage || t('core:noContent:retryAction')}
                </button>
            )}
        </div>
    );
};
